import {
  CountryData,
  PaginatedData,
  ProvinceData,
  RequestOptions,
} from '../../../../types/interfaces'
import { client } from '../../client'

export class CountriesService {
  public async getCountries(options?: RequestOptions) {
    return client.get<PaginatedData<CountryData[]>>('/countries', options)
  }

  public async getCountryById(countryId: number) {
    return client.get<CountryData>(`/countries/${countryId}`)
  }

  public async getProvincesByCountryId(countryId: number) {
    return client.get<PaginatedData<ProvinceData[]>>(
      `/countries/${countryId}/provinces`
    )
  }
}
